import React, { useRef, useState, useEffect } from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import ButtonPrimary from "../../../components/button-primary/ButtonPrimary";
import ArrowBg from "../../../components/arrow-bg/ArrowBg";
import {useWindowWidth} from "../../../services/useWindowWidth";
import {VEDMARKET_LINKS} from '../../../constants';

import styles from './Ecosystem.module.scss';

function Ecosystem() {

    const scrollContainerRef = useRef<HTMLDivElement | null>(null);
    const animationRef = useRef<number | null>(null);

    const cards = [
        {
            title: 'Транспортные компании',
            list: [
                <span>Тарифы на&nbsp;транспортные и&nbsp;экспедиторские услуги</span>,
                <span>Маршруты судов, даты и&nbsp;расписания</span>,
                <span>Отслеживание контейнеров и&nbsp;интеграция с&nbsp;картами</span>
            ],
        },
        {
            title: 'Таможенные представители',
            list: [
                <span>Таможенное оформление</span>,
                <span>Консультационные услуги и&nbsp;документальное сопровождение</span>,
                <span>Специальные таможенные процедуры и&nbsp;режимы</span>
            ],
        },
        {
            title: <span>ФТС<br/>и ЕАЭС</span>,
            list: [
                <span>Определение ТР&nbsp;ТС&nbsp;или ТР&nbsp;ЕАЭС, под действие которых попадает ваш товар</span>,
                <span>Тарифное и&nbsp;нетарифное регулирование</span>,
                <span>Справочник по&nbsp;ТН&nbsp;ВЭД кодам</span>
            ],
        },
        {
            title: 'Финансовые организации',
            list: [
                <span>Валютные платежи и&nbsp;хеджирование рисков</span>,
                <span>Курсы банка, комиссии, валютный контроль</span>,
                <span>Онлайн-подача документов и&nbsp;проверка контрактов</span>
            ],
        },
        {
            title: 'Сертификационные центры',
            list: [
                <span>Разрешительные документы для вашего кода ТН&nbsp;ВЭД</span>,
                <span>Лабораторные испытания образцов</span>,
                <span>Определение стоимости сертификатов и&nbsp;деклараций</span>
            ],
        },
    ]

    const width = useWindowWidth();

    const [shouldScroll, setShouldScroll] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1690);

    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth < 1690);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (!isSmallScreen) return;

        const target = document.getElementById('ecosystem');
        if (!target) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                setShouldScroll(entry.isIntersecting);
            },
            { threshold: 0.2 }
        );

        observer.observe(target);
        return () => observer.disconnect();
    }, [isSmallScreen]);

    useEffect(() => {
        if (!shouldScroll || isHovered || !isSmallScreen) {
            if (animationRef.current !== null) {
                cancelAnimationFrame(animationRef.current);
            }
            return;
        }

        const scroll = () => {
            const el = scrollContainerRef.current;
            if (!el) return;

            el.scrollLeft += 0.25;

            if (el.scrollLeft >= el.scrollWidth / 2) {
                el.scrollLeft = 0;
            }

            animationRef.current = requestAnimationFrame(scroll);
        };

        animationRef.current = requestAnimationFrame(scroll);

        return () => {
            if (animationRef.current !== null) {
                cancelAnimationFrame(animationRef.current);
            }
        };
    }, [isSmallScreen, shouldScroll, isHovered]);

    const duplicatedCards = isSmallScreen ? [...cards, ...cards] : cards.slice(0, 5);

    return (
        <ArrowBg bgImageStyles={{
            top: width >= 768 ? '-57.2%' : '0',
            left: width >= 768 ? '-14.2%' : '0'
        }}>
            <div className={styles.ecosystem} id="ecosystem">
                <Container className={styles.ecosystemContainer}>
                    <Row className="justify-content-center">
                        <Col xl={11} xxl={9}>
                            <h2 className={styles.title}>Единая экосистема логистических решений</h2>
                            <p className={styles.text}>
                                Вэдмаркет собирает всю необходимую информацию от&nbsp;партнеров в&nbsp;реальном времени
                                и&nbsp;анализирует базы данных от&nbsp;регламентирующих организаций.
                            </p>
                            <ButtonPrimary href={VEDMARKET_LINKS.demo} target="_blank" rel="noreferrer" label="Посмотреть демо" isWide className={styles.button}/>
                        </Col>
                    </Row>
                </Container>
                <Row>
                    <Col xs={12} className={styles.wrapper}>
                        <div className={styles.ecosystemCards}
                             ref={scrollContainerRef}>
                            {duplicatedCards.map((card, index) => (
                                <div
                                    className={styles.card}
                                    key={index}
                                    onMouseEnter={() => setIsHovered(true)}
                                    onMouseLeave={() => setIsHovered(false)}
                                    style={{
                                        marginLeft: index === 0 && isSmallScreen ? '80px' : undefined,
                                        marginRight: index === 4 && !isSmallScreen ? '0' : undefined,
                                    }}
                                >
                                    <h3 className={styles.cardTitle}>{card.title}</h3>
                                    <ul className={styles.cardList}>
                                        {card.list.map((item, idx) => (
                                            <li key={idx} className={styles.cardListItem}>{item}</li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </div>
                    </Col>
                </Row>
            </div>
        </ArrowBg>
    );
}

export default Ecosystem;
